import { Object3D } from "three";
import { HandleBoneObject } from "./HandleBoneObject";
import { MeshInfo } from "../../Meshes/MeshInfo";

export class FrontElementObject extends Object3D {

    public handleBones: HandleBoneObject[] = [];
    public widthMeter: number = 0;
    public heightMeter: number = 0;

    constructor() {
        super();
    }
}

export class MeshFrontElementObject extends FrontElementObject {

    public MeshInfo?: MeshInfo;

    constructor() {
        super();
    }
}